import { GridCellProps } from "@progress/kendo-react-grid";
import { ContainerTypeUpdateModeCell } from "./ContainerTypeUpdateModeCell";
import { ColumnMenu } from "../../../Layout/Grid/Filter/ColumnMenu";
import { FoldedUnfoldedDropdownCell } from "../../../Layout/Grid/Cell/FoldedUnfoldedDropdownCell";
import { FoldedUnfoldedColumnMenu } from "../../../Layout/Grid/Filter/FoldedUnfoldedColumnMenu";
import { RC2DropdownCell } from "../../../Layout/Grid/Cell/RC2DropdownCell";
import { ScopeDropdownCell } from "../../../Layout/Grid/Cell/ScopeDropdownCell";
import { kendoDateCell } from "../../../Layout/Grid/Cell/DateCell";
import { GridRowClickProps } from "../../../Layout/Grid/GridRowClickProps";
import { columnForField, defaultColumnWidth } from "../../../Grid/columnForField";
import { PdsrContainer } from "./PdsrContainer";
import { InScopeOutOfScopeColumnMenu } from "../../../Layout/Grid/Filter/InScopeOutOfScopeColumnMenu";
import { YesNoColumnMenu } from "../../../Layout/Grid/Filter/YesNoColumnMenu";
import { MaxStockQuantityCell } from "../PdsrValidationItemGrid/CustomCells/MaxStockQuantityCell";
import { ReadOnlyProps } from "../../../Project/EditProject/ReadOnlyProps";

export const ContainerOverviewGridColumns = ({
  onRowClick,
  isReadOnly,
}: GridRowClickProps & ReadOnlyProps) => {
  const containerTypeUpdateModeCell = (props: GridCellProps) =>
    ContainerTypeUpdateModeCell({
      ...props,
      onRowClick,
    });

  const foldedUnfoldedDropdownCell = (props: GridCellProps) =>
    FoldedUnfoldedDropdownCell({
      ...props,
      editable: false,
      onRowClick,
      isReadOnly,
    });

  const rc2DropdownCell = (props: GridCellProps) =>
    RC2DropdownCell({
      ...props,
      onRowClick,
      isReadOnly,
    });

  const scopeDropdownCell = (props: GridCellProps) =>
    ScopeDropdownCell({
      ...props,
      onRowClick,
      isReadOnly,
    });

  const maxStockQuantityCell = (props: GridCellProps) => {
    return MaxStockQuantityCell({
      ...props,
      isReadOnly,
    });
  };

  return [
    columnForField<PdsrContainer>("UpdateMode", {
      title: "Update Mode",
      filter: "numeric",
      cell: containerTypeUpdateModeCell,
      width: "200px",
      columnMenu: ColumnMenu,
    }),
    columnForField<PdsrContainer>("InboundDock", {
      title: "Inbound Dock",
      width: "200px",
      columnMenu: ColumnMenu,
    }),
    columnForField<PdsrContainer>("ContainerType", {
      title: "Container Type",
      width: "200px",
      columnMenu: ColumnMenu,
    }),
    columnForField<PdsrContainer>("FoldedUnfolded", {
      title: "Folded / Unfolded",
      width: defaultColumnWidth,
      cell: foldedUnfoldedDropdownCell,
      columnMenu: FoldedUnfoldedColumnMenu,
    }),
    columnForField<PdsrContainer>("Rc2Flag", {
      title: "Limited Pool Size",
      editable: true,
      width: defaultColumnWidth,
      cell: rc2DropdownCell,
      columnMenu: YesNoColumnMenu,
    }),
    columnForField<PdsrContainer>("MaxStockQuantity", {
      title: "Max Stock Quantity",
      cell: maxStockQuantityCell,
      filter: "numeric",
      width: defaultColumnWidth,
    }),
    columnForField<PdsrContainer>("InScope", {
      title: "Scope",
      width: defaultColumnWidth,
      cell: scopeDropdownCell,
      columnMenu: InScopeOutOfScopeColumnMenu,
    }),
    columnForField<PdsrContainer>("ImportDate", {
      title: "Import Date",
      width: "220px",
      filter: "date",
      cell: kendoDateCell(onRowClick),
      columnMenu: ColumnMenu,
    }),
    columnForField<PdsrContainer>("LastModifiedUser", {
      title: "Last Modified By",
      resizable: true,
      width: "250px",
    }),
    columnForField<PdsrContainer>("LastModifiedDate", {
      title: "Last Modified",
      width: "320px",
      filter: "date",
      cell: kendoDateCell(onRowClick),
      columnMenu: ColumnMenu,
    }),
  ];
};
